import type { SessionService } from '@efdigital/ll-addon-auth';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import Footer from '../components/application/footer.gts';
import Header from '../components/application/header.gts';

export default class ApplicationTemplate extends Component {
  @service declare session: SessionService;

  reload = () => {
    window.location.reload();
  };

  <template>
    {{pageTitle "Hult Ashridge Admin V2"}}
    {{#if this.session.cached.isAuthenticated}}
      <div class="d-flex flex-column mh-dvh-100">
        <Header />

        <div class="flex-grow-1">
          {{outlet}}
        </div>

        <Footer />
      </div>
    {{else}}
      <div class="container">
        {{#if this.session.cached.isAuthenticating}}
          <div class="d-flex justify-content-center">
            <div class="spinner-grow" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        {{else}}
          <h1 class="text-center">Please log in to continue</h1>
          <button
            class="btn btn-primary"
            type="button"
            {{on "click" this.reload}}
          >Log in</button>
        {{/if}}
      </div>
    {{/if}}
    <div id="ember-bootstrap-wormhole"></div>
  </template>
}
